module.exports = __webpack_public_path__ + "static/media/19-Ultra R6.c0889b27.jpg";